import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviBookmark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 22.2 24.57"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.76 24.57c-.35 0-.7-.13-.97-.38l-8.7-8.02-8.68 8.02c-.42.39-1.02.49-1.54.26-.53-.23-.87-.75-.87-1.34V5.07C0 2.27 2.21 0 4.92 0h12.36c2.71 0 4.92 2.27 4.92 5.07v18.05a1.445 1.445 0 0 1-1.44 1.45Zm-9.67-10.76c.24 0 .49.09.68.26l8.43 7.77V5.07C20.2 3.38 18.89 2 17.28 2H4.92C3.31 2 2 3.38 2 5.07v16.77l8.41-7.77c.19-.18.44-.27.68-.27Z"
        style={{
          fill: '#005096',
        }}
      />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviBookmark
